import { createAction } from "@reduxjs/toolkit";

export const initCpq = createAction<any>("_root/initCpq");
export const clearState = createAction("_root/clearState");
export const loadWizardState = createAction<any>("_root/loadWizardState");
